import { Link } from 'react-router-dom';
import styles from './index.module.scss';
import SiteTopNav from '@/components/SiteTopNav';

const GradeAndCharacter = () => {
  return (
    <div className={styles['article-page']}>
      <div className={styles.page}>
        <header className={styles['article-header']}>
          <SiteTopNav variant="light" />
        </header>

        <main className={styles['article-main']}>
          <Link className={styles['article-back']} to="/academy/hardwood-basics">
            ← Back to Flooring 101
          </Link>

          <p className={styles['article-eyebrow']} data-motion="copy">
            Sakura Floors Academy
          </p>

          <h1 className={styles['article-title']} data-motion="hero">
            Grade and Character
          </h1>

          <p className={styles['article-intro']} data-motion="copy">
            Grade describes how much natural variation appears across a floor — not the quality of
            the wood itself.
          </p>

          <p className={styles['article-intro']} data-motion="copy">
            Choosing the right grade is about matching the visual rhythm of a room to your personal
            style, from clean and uniform to rich and rustic.
          </p>

          <section className={styles['article-section']} data-motion="section">
            <p className={styles['article-section__eyebrow']}>Grades</p>

            <h2 className={styles['article-section__title']}>Understanding Grade</h2>

            <div className={styles['article-feature-list']}>
              <div className={styles['article-feature']}>
                <h3 className={styles['article-feature__title']}>Prime Grade</h3>
                <p className={styles['article-feature__text']}>
                  A clean, uniform look with minimal color variation or markings.
                </p>
              </div>

              <div className={styles['article-feature']}>
                <h3 className={styles['article-feature__title']}>Select Grade</h3>
                <p className={styles['article-feature__text']}>
                  A balanced look with subtle character and moderate variation.
                </p>
              </div>

              <div className={styles['article-feature']}>
                <h3 className={styles['article-feature__title']}>Character Grade</h3>
                <p className={styles['article-feature__text']}>
                  The most natural, rustic expression of the species, embracing knots and grain
                  variation.
                </p>
              </div>
            </div>
          </section>

          <section className={styles['article-section']} data-motion="section">
            <p className={styles['article-section__eyebrow']}>Natural Markings</p>

            <h2 className={styles['article-section__title']}>
              Knots, Sapwood, and Mineral Streaks
            </h2>

            <p className={styles['article-section__text']}>
              Higher-character grades embrace the natural markings found in real hardwood, each
              adding its own authenticity and individuality to a plank.
            </p>

            <ul className={styles['article-list']}>
              <li>Knots — small, natural voids or dense growth points in the grain</li>
              <li>Sapwood — lighter-toned wood from just beneath the bark</li>
              <li>Mineral streaks — natural color veining caused by minerals in the soil</li>
            </ul>
          </section>

          <section className={styles['article-section']} data-motion="section">
            <p className={styles['article-section__eyebrow']}>Expectation</p>

            <h2 className={styles['article-section__title']}>Living with Natural Variation</h2>

            <p className={styles['article-section__text']}>
              Expect some difference between boards — it&rsquo;s part of what makes real wood
              genuine. Once installed across a full room, this variation tends to blend into an
              overall texture rather than standing out board by board.
            </p>
          </section>
        </main>
      </div>
    </div>
  );
};

export default GradeAndCharacter;
